import {Dayjs} from "dayjs";
import {Field, FieldPostBody, FieldWithoutID} from "../types/domain/field";
import {CropCycle} from "../types/domain/cropCycle";
import {toCropCyclePost} from "../utils/cropCycleUtils";
import {FIELD_INITIAL_VALUES} from "./constants";

const parseAndAssignValue = (field: FieldWithoutID, key: keyof FieldWithoutID, defaultValue: number | null) => {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const parsedValue: number = parseFloat(field[key] as string);
    if (!Number.isNaN(parsedValue)) {
        //@ts-expect-error we are using this only for numeric props, but TS doesn't know about it.
        field[key] = parsedValue;
    } else {
        //@ts-expect-error we are using this only for numeric props, but TS doesn't know about it.
        field[key] = defaultValue;
    }
};

export const toFieldPostBody = (field: Field | FieldWithoutID): FieldPostBody => {
    const cropCycles = field.cropCycles.map((cc) => toCropCyclePost(cc));
    parseAndAssignValue(field, "satSoilMoistBias", FIELD_INITIAL_VALUES.satSoilMoistBias);
    parseAndAssignValue(field, "irrigationInterval", FIELD_INITIAL_VALUES.irrigationInterval);
    parseAndAssignValue(field, "desiredMoistureLevel", FIELD_INITIAL_VALUES.desiredMoistureLevel);
    parseAndAssignValue(field, "irrigationCriteria", FIELD_INITIAL_VALUES.irrigationCriteria);
    parseAndAssignValue(field, "irrigationDefault", FIELD_INITIAL_VALUES.irrigationDefault);
    parseAndAssignValue(field, "onFarmEfficiencyMin", FIELD_INITIAL_VALUES.irrigationDefault);
    parseAndAssignValue(field, "minAppliedWater", FIELD_INITIAL_VALUES.irrigationDefault);
    parseAndAssignValue(field, "maxAppliedWater", FIELD_INITIAL_VALUES.irrigationDefault);

    /* eslint-disable @typescript-eslint/no-explicit-any */
    const parsedValue: number = parseFloat(field.satSoilMoistBias as any as string);
    if (!Number.isNaN(parsedValue)) {
        field.satSoilMoistBias = parsedValue;
    } else {
        field.satSoilMoistBias = FIELD_INITIAL_VALUES.satSoilMoistBias;
    }
    const parsedValue2: number = parseFloat(field.irrigationDefault as any as string);
    if (!Number.isNaN(parsedValue2)) {
        field.irrigationDefault = parsedValue2;
    } else {
        field.irrigationDefault = FIELD_INITIAL_VALUES.irrigationDefault;
    }

    const result: FieldPostBody = {
        ...field,
        cropCycles,
    };
    return result;
};

export const getLatestCropCycle = (field: Field | undefined): CropCycle | null => {
    if (!field) {
        return null;
    }
    const cropCycles = field.cropCycles;
    //We take into account the cropCycles are sorted by Date, we pick the latest one.
    if (cropCycles && cropCycles.length > 0) {
        return cropCycles[0];
    }
    return null;
};

export const getCropCycleForDate = (field: Field, date: Dayjs | null): CropCycle | null => {
    if (!date) {
        return getLatestCropCycle(field);
    }
    for (const cycle of field.cropCycles) {
        if (cycle.plantedDate && (!cycle.estHarvestDate || date.isBefore(cycle.estHarvestDate, "day"))) {
            if (date.isSame(cycle.plantedDate, "day") || date.isAfter(cycle.plantedDate, "day")) {
                return cycle;
            }
        }
    }
    return getLatestCropCycle(field);
};

export const getLatestCropId = (field: Field | undefined): string | null => {
    const cropCycle = getLatestCropCycle(field);
    if (cropCycle) {
        return cropCycle.cropId;
    }
    return null;
};

export const getCropIdForDate = (field: Field, date: Dayjs | null): string | null => {
    const cropCycle = getCropCycleForDate(field, date);
    if (cropCycle) {
        return cropCycle.cropId;
    }
    return null;
};
